import { combineReducers } from "redux";
import languageReducer from "../../Redux/reduxToolkit";
import popupReducer from "../../Redux/toggle";
import teamReducer from "../../Redux/group";
import userReducer from "../../Redux/userSlice";
import emailDuplication from "./checkEmailDuplication";
import loginUser from "./loginUser";
import loginUserTenant from "./loginUserTenant";
import teamSectionReducer from "../../Redux/teamSlice";
import ticketsReducer from "./getAllTickets";
import trafficUserDetailSidebarReducer from "./trafficUserDetailSidebarSlice";

import getTicketByIdReducer from "./getTicketById";
import getTicketUserHistoryReducer from "./getTicketUserHistory";
import getCustomerConversationHistoryReducer from "./getCustomerConversationHistory";
import updateTicketReducer from "./updateTicket";
import getTicketMessagesByIdReducer from "./getTicketMessagesById";
import agentReplyToTicketReducer from "./agentReplyToTicket";
import DeleteTicket from "./deleteTicket";
import assignTicketToSelfReducer from "./assignTicketToSelf";
import getTagsByBusinessIdReducer from "./getTagsByBusinessId";
import getChatTagsByBusinessIdReducer from "./getChatTagsByBusinessId";
import addTagsToChatReducer from "./addTagsToChat";
import ticketDetailSidebarReducer from "./ticketDetailSidebarSlice";
import userDetailSidebarReducer from "./userDetailSidebarSlice";
import getUserSessionsReducer from "./getUserSessions";
import createChatTagReducer from "./createChatTag";
import getTagsByGroupIdReducer from "./getTagsByGroupId";
import deleteBusinessTagReducer from "./deleteBusinessTag";
import getChatStatsReducer from "./getChatStats";
import getTicketStatsReducer from "./getTicketStats";
import getChatGraphStatsReducer from "./getChatGraphStats";
import getTicketGraphStatsReducer from "./getTicketGraphStats";
import getChatSatisfactionGraphStatsReducer from "./getChatSatisfactionGraphStats";
import getCoUserStatsReducer from "./getCoUserStats";
import getKbStatsReducer from "./getKbStats";
import getUserTrafficListReducer from "./getUserTrafficList";
import websiteTrafficGraphStatsReducer from "./getWebsiteTrafficGraphStats";
import getAnalyticsOverviewStatsReducer from './getAnalyticsOverviewStats';
import getHeatMapStatsReducer from './getHeatMapStats';
import getChatAnalyticsStatsReducer from './getChatAnalyticsStats';
import getCsatAnalyticsStatsReducer from './getCsatAnalyticsStats';
import getChatPerformanceStatsReducer from './getChatPerformanceStats';
import getAnalyticsTicketsStatsReducer from "./getAnalyticsTicketsStats";
import getTicketTagUsageStatsReducer from "./getTicktetTagUsageStats";
import getTicketPerformanceStatsReducer from "./getTicketsPerformanceStats";
import getTicketSourceStatsReducer from "./getTicketsSourceStats";
import getAnalyticsAgentsStatsReducer from "./geAnalyticsAgentsStats";
import getChatTagUsageStatsReducer from './getChatTagUsageStats';
import getAgentsChatsStatsReducer from './getAgentsChatsStats';
import getAgentsTicketsStatsRedcuer from "./getAgentsTicketStats";
import getAgentsCsatStatsRedcuer from "./getAgentsCsatStats";

import getAgentResponseTimeStatsReducer from './getAgentResponseTimeStats';
import getAgentsAvailabilityStatsRedcuer from "./getAgentsAvailability";
import getKbArticlesReducer from "./getKbArticles";
import kbOverviewReducer from "./mvKbOverview";
import kbActionsReducer from "./kbActions";
import removeKbArticleFromCategoryReducer from "./removeKbArticleFromCategory";
import kbBulkActionsReducer from "./kbBulkActions";
import createKbArticleReducer from "./createKbArticle";
import getAllKbTagsReducer from "./getTagsToKnowledgeBase";
import getKbReviewArticlesReducer from "./getKbReviewArticles";
import getKbArticleByIdReducer from "./getKbArticleById";
import getPublicArticleByIdReducer from "./getPublicArticleById";
import updateKbArticleReducer from "./updateKbArticle";
import createKbFeedbackReducer from "./createKbFeedback";
import createExternalKbFeedbackReducer from "./createExternalKbFeedback";
import createArticleReactionReducer from "./createArticleReaction";


import createKbTagReducer from "./createTagToKnowledgeBase";
import deleteKbTagReducer from "./deleteKBTag";
import updateKbUserRoleReducer from "./updateKbUserRole";
import createKbCategoryReducer from './createCategoryToKB'
import getAllKbCategoriesReducer from "./getCategoriesToKnowledgeBase";
import updateKbCategoryReducer from "./updateCategoryToKb";
import deleteKbCategoryReducer from "./deleteKbCategory";
import getKbFeedbackReducer from "./getKbFeedbackQueue";
import assignFeedbackReducer from "./assignFeedbackQueue";
import completeFeedbackReducer from "./completeFeedbackQueue";
import deleteKbFeedbackReducer from "./deleteFeedbackQueue";
// Config for persisting loginTokenCoUser

import getFeaturedArticlesReducer from "./getFeaturedArticles";
import getAnalyticsKbStatsReducer from "./getAnalyticsKbStats";
import getKbTagUsageStatsReducer from "./getKbTagUsageStats";
import getKbArticlePerformanceReducer from "./getAnalyticsKbArticlePerformance";
import validateInvitationReducer from "./AppValidateInvitation";
import validateInvitationGenerateReducer from "./validateInvitationGenerate";
import getFeaturedArticlesExternalReducer from "./getFeatureArticleExternal";
import getAllExternalKbCategoriesReducer from './getExternalAllCategories'
import getExternalArticleByCategoryReducer from "./getExternalArticleByCategory";
import getPopularArticlesExternalReducer from "./getExternalPopularArticle";
import getAllExternalArticlesReducer from "./getAllExternalArticles";
import kbSettingsReducer from "./kbSettings";
import getExternalKbSettingsReducer from "./getExternalKbSettings";
import gettopSearchTermsStatsReducer from "./getKbTopSearchTerms";
import listUserReducer from "./listCoUser";
import globalSearchReducer from "./globalSearch";
import notificationsReducer from "./notifications";
import mailDomainAuthReducer from "./mailDomainAuth";
import ticketFromEmailReducer from "./ticketFromEmail";
import businessTicketFromEmailReducer from "./businessTicketFromEmail";
import updatePasswordReducer from "./updatePassword";
import peopleTeamsReducer from "./teamsApi";
import peopleCustomersReducer from "./customersApi";
import peopleAgentsReducer from "./agentsApi";
import peopleGroupsReducer from "./groupsApi";
import postAnalyticsExportReducer from "./postAnalyticsExport";
import getAnalyticsExportsReducer from "./getAnalyticsExports";
import widgetSettingsGroupReducer from "./widgetSettingsGroupApi";
import groupTicketFromEmailReducer from "./groupTicketFromEmailApi";
import mailDomainAuthApiReducer from "./mailDomainAuthApi";
import businessEmailReducer from "./businessEmailApi";
import twoFactorReducer from "./twoFactorApi";
import notificationPreferencesReducer from "./notificationPreferencesApi";
import workspaceSettingsReducer from "./workspaceSettingsApi";
import cannedMessagesReducer from "./cannedMessagesApi";
import tagsReducer from "./tagsApi";
import ticketRoutingReducer from "./ticketRoutingApi";
import sendTranscriptReducer from "./sendTranscript";
const rootReducer = combineReducers({
  language: languageReducer,
  popup: popupReducer,
  team: teamReducer,
  emailDuplication: emailDuplication.reducer,
  loginToken: loginUser.reducer,
  loginTokenCoUser: loginUserTenant.reducer,
  user: userReducer,
  teamSection: teamSectionReducer,
  tickets: ticketsReducer,
  getTicketById: getTicketByIdReducer,
  ticketUserHistory: getTicketUserHistoryReducer,
  customerConversationHistory: getCustomerConversationHistoryReducer,
  updateTicket: updateTicketReducer,
  ticketMessages: getTicketMessagesByIdReducer,
  agentReply: agentReplyToTicketReducer,
  deleteTicket: DeleteTicket.reducer,
  assignTicketToSelf: assignTicketToSelfReducer,
  getTagsByBusinessId: getTagsByBusinessIdReducer,
  getChatTagsByBusinessId: getChatTagsByBusinessIdReducer,
  addTagsToChat: addTagsToChatReducer,
  ticketDetailSidebar: ticketDetailSidebarReducer,
  userDetailSidebar: userDetailSidebarReducer,
  trafficUserDetailSidebar: trafficUserDetailSidebarReducer,
  getUserSessions: getUserSessionsReducer,
  createChatTag: createChatTagReducer,
  getTagsByGroupId: getTagsByGroupIdReducer,
  deleteBusinessTag: deleteBusinessTagReducer,
  chatStats: getChatStatsReducer,
  ticketStats: getTicketStatsReducer,
  chatGraphStats: getChatGraphStatsReducer,
  ticketGraphStats: getTicketGraphStatsReducer,
  chatSatisfactionGraphStats: getChatSatisfactionGraphStatsReducer,
  coUserStats: getCoUserStatsReducer,
  kbStats: getKbStatsReducer,
  userTraffic: getUserTrafficListReducer,
  websiteTrafficGraphStats: websiteTrafficGraphStatsReducer,
  analyticsOverviewStats: getAnalyticsOverviewStatsReducer,
  heatMapStats: getHeatMapStatsReducer,
  chatAnalyticsStats: getChatAnalyticsStatsReducer,
  csatAnalyticsStats: getCsatAnalyticsStatsReducer,
  chatPerformanceStats: getChatPerformanceStatsReducer,
  analyticsTicketsStats: getAnalyticsTicketsStatsReducer,
  getTicketTagUsageStats: getTicketTagUsageStatsReducer,
  ticketPerformanceStats: getTicketPerformanceStatsReducer,
  ticketSourceStats: getTicketSourceStatsReducer,
  agentAnalyticsStats: getAnalyticsAgentsStatsReducer,
  chatTagUsageStats: getChatTagUsageStatsReducer,
  agentsChatsStats: getAgentsChatsStatsReducer,
  agentsTicketsStats: getAgentsTicketsStatsRedcuer,
  agentsCsatStats: getAgentsCsatStatsRedcuer,
  agentResponseTimeStats: getAgentResponseTimeStatsReducer,
  agentsAvailabilityStats: getAgentsAvailabilityStatsRedcuer,
  kbArticles: getKbArticlesReducer,
  featuredArticles: getFeaturedArticlesReducer,
  kbOverview: kbOverviewReducer,
  kbActions: kbActionsReducer,
  removeKbArticleFromCategory: removeKbArticleFromCategoryReducer,
  kbBulkActions: kbBulkActionsReducer,
  createKbArticle: createKbArticleReducer,
  createKbTag: createKbTagReducer,
  getAllKbTags: getAllKbTagsReducer,
  kbReviewArticles: getKbReviewArticlesReducer,
  deleteKbTag: deleteKbTagReducer,
  updateKbUserRole: updateKbUserRoleReducer,
  createKbCategory: createKbCategoryReducer,
  getAllKbCategories: getAllKbCategoriesReducer,
  updateKbCategory: updateKbCategoryReducer,
  deleteKbCategory: deleteKbCategoryReducer,
  kbArticleDetail: getKbArticleByIdReducer,
  publicArticleDetail: getPublicArticleByIdReducer,
  updateKbArticle: updateKbArticleReducer,
  createKbFeedback: createKbFeedbackReducer,
  createExternalKbFeedback: createExternalKbFeedbackReducer,
  articleReaction: createArticleReactionReducer,
  KbFeedbackQueue: getKbFeedbackReducer,
  assignFeedback: assignFeedbackReducer,
  completeFeedback: completeFeedbackReducer,
  deleteKbFeedback: deleteKbFeedbackReducer,
  analyticsKbStats: getAnalyticsKbStatsReducer,
  kbTagUsageStats: getKbTagUsageStatsReducer,
  kbArticlePerformance: getKbArticlePerformanceReducer,
  validateInvitation: validateInvitationReducer.reducer,
  validateInvitationGenerate: validateInvitationGenerateReducer.reducer,
  featuredArticlesExternal: getFeaturedArticlesExternalReducer,
  externalCatgroiesKb: getAllExternalKbCategoriesReducer,
  externalArticleByCategory: getExternalArticleByCategoryReducer,
  popularArticlesExternal: getPopularArticlesExternalReducer,
  allExternalArticles: getAllExternalArticlesReducer,
  kbSettings: kbSettingsReducer,
  externalKbSettings: getExternalKbSettingsReducer,
  topSearchTermsStats: gettopSearchTermsStatsReducer,
  coUsers: listUserReducer,
  globalSearch: globalSearchReducer,
  notifications: notificationsReducer,
  mailDomainAuth: mailDomainAuthReducer,
  ticketFromEmail: ticketFromEmailReducer,
  businessTicketFromEmail: businessTicketFromEmailReducer,
  updatePassword: updatePasswordReducer,
  peopleTeams: peopleTeamsReducer,
  peopleCustomers: peopleCustomersReducer,
  peopleAgents: peopleAgentsReducer,
  peopleGroups: peopleGroupsReducer,
  analyticsExport: postAnalyticsExportReducer,
  analyticsExportsList: getAnalyticsExportsReducer,
  widgetSettingsGroup: widgetSettingsGroupReducer,
  groupTicketFromEmail: groupTicketFromEmailReducer,
  mailDomainAuthApi: mailDomainAuthApiReducer,
  businessEmail: businessEmailReducer,
  twoFactor: twoFactorReducer,
  notificationPreferences: notificationPreferencesReducer,
  workspaceSettings: workspaceSettingsReducer,
  cannedMessages: cannedMessagesReducer,
  tags: tagsReducer,
  ticketRouting: ticketRoutingReducer,
  sendTranscript: sendTranscriptReducer,
});


export default rootReducer;
